import React from "react";
import PressFooter from "../../components/BBFFooter";

export default function ButlerBullseye() {
  return (
    <div className="press-release" style={{ maxWidth: "800px", margin: "2rem auto", textAlign: "left", lineHeight: "1.6" }}>
      <h4 style={{ fontWeight: "bold", marginBottom: "1rem" }}>
        MEDIA ADVISORY — FOR IMMEDIATE RELEASE
      </h4>

      <h1 style={{ marginBottom: "1rem" }}>
        Criminal Complaints Filed: The “Butler Bullseye” and Allegations Against Joe Biden and the Rosemont Network
      </h1>
      <p style={{ margin: 0 }}>
        August 21, 2025
      </p>
      <p>
        <strong>Butler, PA</strong> — Private criminal complaints have been filed in Butler County and
        Luzerne County (Wilkes-Barre, PA) alleging that Joseph R. Biden, Hunter Biden, and associates
        in the Rosemont Network deliberately constructed what has become known as the “Butler Bullseye” —
        a symbolic and geographic kill zone where President Donald J. Trump was nearly assassinated on July 13, 2024.
      </p>

      <p>
        These are allegations with sworn affidavits, filed under Pennsylvania Rule 506, which allows any citizen
        to submit a private criminal complaint for offenses with a Pennsylvania nexus. The filings include exhibits,
        forensic maps, and sworn statements. All named individuals are presumed innocent unless proven guilty.
      </p>

      <h2>The Butler Bullseye: Map and Metaphor</h2>
      <p>
        The complaints describe how two axes — north–south and east–west — intersect in Butler, Pennsylvania:
      </p>
      <ul>
        <li>
          <strong>North–South Axis (Rosemont Corridor):</strong> Anchored by Rosemont Farms in Franklin, PA (north) 
          and Rosemont Farms in Fox Chapel, PA (south). The southern farm was identified in Hunter Biden’s 
          business records as the namesake for Rosemont Seneca Partners, LLC, and was passed to Teresa Heinz-Kerry 
          after the death of her husband, Senator John Heinz III, in a 4/4/1991 plane crash near Rosemont College, 
          in Rosemont, Pennsylvania — on the 23rd anniversary of the assassination of Dr. Martin Luther King, Jr.
        </li>
        <li>
          <strong>East–West Axis:</strong> Anchored in the west by the East Palestine, OH train derailment (2/3/23),
          and extending eastward into Pennsylvania, 33 miles west of Butler, with Punxsutawney marking the eastern end 
          of the crosshair, intersecting the Rosemont Seneca Corridor north–south axis squarely in Butler.
        </li>
      </ul>
      <p>
        Together, the axes form the “Butler Bullseye,” cited as both operational map and political metaphor —
        reinforced by President Biden’s own remark about putting Trump “in a bullseye,” exactly 11 days after Biden’s
        nationally televised debate failure, and 5 days before President Trump found himself in that very bullseye.
      </p>

      <h2>Built in Blood: The Wilkes-Barre Connection</h2>
      <p>
        The filings further allege that the Rosemont entity itself was founded on bloodshed, linking back to June 25, 2009 —
        the incorporation date of Rosemont Seneca Partners, LLC. That date marked the 40th anniversary of the kidnapping 
        and murder of Joan Marie Dymond, a Luzerne County (Wilkes-Barre) native, just 14 years old.
      </p>
      <p>
        Just 23 days later, another Wilkes-Barre native, Mary Jo Kopechne, was killed at Chappaquiddick (7/18/1969).
        Both victims lived within miles of Scranton, PA — Joe Biden’s hometown.
      </p>
      <p style={{ marginBottom: "1rem", fontSize: "0.95rem" }}>
        These filings were submitted by Robert J. Antonellis under Pennsylvania Rule 506.
      </p>
      <p style={{ marginBottom: "1rem", fontSize: "0.95rem" }}>
        Download the Butler Brief at{" "}
        <a
          href="/#downloads"
          style={{ color: "#4dabf7", textDecoration: "underline" }}
        >
          https://ButlerBrief.com/#downloads
        </a>.
      </p>
      <PressFooter />
    </div>
  );
}
